"use strict";

var _objectWithoutProperties = require("/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/objectWithoutProperties.js");
const _excluded = ["className", "label", "href"];
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _icon = _interopRequireDefault(require("../icon"));
var _indexModule = _interopRequireDefault(require("./index.module.scss"));
const BackLink = _ref => {
  let {
      className,
      label = 'Back',
      href = 'javascript: history.back()'
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("a", (0, _extends2.default)({
    href: href
  }, restProps, {
    className: (0, _classnames.default)(_indexModule.default.root, className)
  }), /*#__PURE__*/_react.default.createElement(_icon.default, {
    size: "medium",
    className: (0, _classnames.default)(_indexModule.default.icon, 'arrow-left'),
    type: "arrow-left"
  }), label);
};
var _default = exports.default = BackLink;